import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=1ed94c71&"
import script from "./dashBoard.vue?vue&type=script&lang=ts&"
export * from "./dashBoard.vue?vue&type=script&lang=ts&"
import style0 from "./dashBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dashBoard.vue"
export default component.exports